import React, { FunctionComponent, useEffect, useState } from 'react';
import { FlexContainer, LoadingContainer } from '@/components/Layout/Container';
import { Dropzone } from '@/components/Dropzone/Dropzone';
import { ACCEPTED_FILES_IMAGE } from '@/constants';
import { Paper } from '@mui/material';

type LogoDropZoneProps = {
    onLogoChange: (nextLogo: File) => void;
    logo?: File;
    isLoading?: boolean;
};

export const LogoDropZone: FunctionComponent<
    React.PropsWithChildren<LogoDropZoneProps>
> = ({ logo, onLogoChange, isLoading }) => {
    const [image, setImage] = useState('');

    useEffect(() => {
        setImage(logo ? URL.createObjectURL(logo) : '');
    }, [logo]);
    return (
        <>
            {isLoading ? (
                <LoadingContainer />
            ) : (
                <>
                    {image ? (
                        <Paper
                            elevation={3}
                            sx={{
                                width: '100%',
                                height: '100%',
                                backgroundImage: `url("${image}")`,
                                backgroundPosition: 'center center',
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                            }}
                        />
                    ) : (
                        <FlexContainer
                            sx={{
                                width: '100%',
                                height: '100%',
                            }}
                        >
                            <Dropzone
                                accept={ACCEPTED_FILES_IMAGE}
                                onDrop={async (acceptedFiles) => {
                                    const [file] = acceptedFiles;

                                    if (file) {
                                        setImage(URL.createObjectURL(file));

                                        onLogoChange(file);
                                    }
                                }}
                            />
                        </FlexContainer>
                    )}
                </>
            )}
        </>
    );
};
